export default function auth({ next, store, permission, router }) {
    if (permission && !store.state.auth.user.permissions.includes(permission)) {
        return router.push(({
            name: '403'
        }))
    }
    return next()
}